import Cookies from "js-cookie"

export const removeUserCache = () =>{
    Cookies.remove("user")
    localStorage.removeItem("resumes")
    localStorage.removeItem("resumes_fetched_at")
}